import { Footer } from "../../components/Footer/Footer"
import { Header } from "../../components/Header/Header"
import Article from "./Article/Article"

const ArticlePage = () => {
    return (
        <>
            <Header />
            <Article />
            <Footer />
        </>
    )
}

export default ArticlePage